import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import {
  CREATOR_SCRIPT_JOB_STATUS,
  ICreatorScriptGeneratorJobDetail,
} from "../types";

const JOB_POLL_MS = 3000;

const RESTING_SCRIPT_JOB = new Set<string>([
  CREATOR_SCRIPT_JOB_STATUS.waitingUserInputs,
  CREATOR_SCRIPT_JOB_STATUS.conceptualised,
  CREATOR_SCRIPT_JOB_STATUS.ready,
  CREATOR_SCRIPT_JOB_STATUS.failed,
]);

export function useGetCreatorScriptGeneratorJob(creatorScriptGeneratorJobId: string) {
  const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
    queryKey: [AI_WORKSPACE_QUERY_KEYS.CREATOR_SCRIPT_JOB, creatorScriptGeneratorJobId],
    queryFn: () => AiWorkspaceService.getCreatorScriptGeneratorJob(creatorScriptGeneratorJobId),
    enabled: !!creatorScriptGeneratorJobId,
    refetchIntervalInBackground: true,
    refetchInterval: (query) => {
      const job = (query.state.data as BackednResponse<ICreatorScriptGeneratorJobDetail> | undefined)
        ?.data;
      if (!job || !RESTING_SCRIPT_JOB.has(job.status)) return JOB_POLL_MS;
      return false;
    },
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) ToastService.error(errorMessage);
  }, [errorMessage]);

  return {
    job: data?.data,
    isLoading,
    isFetching,
    refetch,
  };
}
